import axios from "axios"
import { useEffect, useState } from "react"
import { Outlet, Navigate } from "react-router-dom"
import { API_BASE_URL, NUMBER_ADMIN } from "../../config/config"
import { OrbitProgress } from "react-loading-indicators"

// protection des routes Premium
const ProtectedRoutes = () => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/auth/me`, { withCredentials: true })
      .then((res) => {
        console.log("Réponse API :", res.data) // debug
        setUser(res.data) // l’API renvoie l’objet user
      })
      .catch((err) => {
        console.error(err)
        setUser(null)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

    if (loading) {
        return (
            <>
            <div className="text-center mt-20 text-gray-400"><OrbitProgress variant="track-disc" color="#125f69ff" size="small" text="Chargement..." textColor="#006115ff" /> </div>
            </>
        )
  }

  if (user && user.phone === NUMBER_ADMIN) {
    return <Outlet />
  } else {
    return <Navigate to="/mksp/maxicatch" replace />
  }
}

export default ProtectedRoutes
